import { AirflowUISpecCategory, UISpecCategory } from '@common/enums';
import { ComponentList as ComponentListType, GemRecord } from '@common/gems/types';
import { ColumnsType, Table } from '@prophecy/ui-v3';
import { nanoid } from 'nanoid';
import { useEffect, useMemo, useState } from 'react';

type GemTableProps = {
  isLoading: boolean;
  language: string;
  gemType: UISpecCategory | AirflowUISpecCategory;
  columns: ColumnsType<GemRecord>;
  data: ComponentListType;
  airflowData: GemRecord[];
  isAirflow?: boolean;
};

type ComponentListKeys = keyof ComponentListType;
const defaultListKey = 'gems' as ComponentListKeys;
const categoryToListKey: { [key in UISpecCategory]?: ComponentListKeys } = {
  [UISpecCategory.SourceTarget]: 'formats' as ComponentListKeys
};

export function GemTable({ isLoading, language, gemType, columns, data, isAirflow, airflowData }: GemTableProps) {
  const [list, setList] = useState<GemRecord[]>([]);

  useEffect(() => {
    if (isAirflow) {
      setList(airflowData);
    } else if (data) {
      setList(data[categoryToListKey[gemType as UISpecCategory] || defaultListKey] || []);
    }
  }, [gemType, data, isAirflow, airflowData]);

  const tableSource = useMemo(
    () =>
      list
        .filter((item) => item.language === language && item.category === gemType)
        .map((item) => ({ ...item, id: nanoid() })),
    [gemType, language, list]
  );

  return (
    <Table
      height={'100%'}
      virtualize={true}
      loading={isLoading}
      dataSource={tableSource}
      columns={columns}
      data-test-id='gem-list-table'
    />
  );
}
